module.exports = __webpack_public_path__ + "static/media/android.48a85df9.png";